export const darkTheme = {
    backgroundSecondary: "#313338",
    backgroundPrimary: "#0f0f0f",
    txtPrimary: "#fff",
    txtSecondary: "#00e5ff",
    surface: "#1a1a1a",
    surfaceSecondary: "#2b2b2b",
    boxShadow: "0 2px 4px rgba(214, 214, 214, 0.62)",
    borderSecondary: "#ff3fdf",
    btn: "#3fffb5ff",
    icon: '#ffff00',
    iconHover: '#ffa500',

    //estilos del carrito
    cartBkg: "linear-gradient(180deg, #0b0b0f 0%, #12121a 100%)",
    cartBorder: "rgba(255, 77, 0, 0.6)",
    cartBoxShadow: "0 0 25px rgba(255, 77, 0, 0.4)",
    cartHeaderGradient: "linear-gradient(90deg, #ff9900, #ff4d00)",
    cartItemBackground: "rgba(20, 20, 30, 0.84)",
    cartItemHoverGradient: "linear-gradient(90deg, rgba(255, 77, 0, 0.1) 0%, rgba(0, 229, 255, 0.1) 100%)",
    cartButtonBackground: "rgba(255, 77, 0, 0.15)",

    //estilos del buscador
    searchBkg: "rgba(0, 31, 63, 0.8)",
    searchBorder: "rgba(255, 153, 0, 0.5)",
    searchBoxShadow: "0 0 12px rgba(255, 77, 0, 0.5)",
    searchIcon: "#ff9900",
    searchIconHover: "#ff4d00",
    searchPlaceholder: "rgba(255, 255, 255, 0.6)",
    searchButtonGradient: "linear-gradient(90deg, #ff4d00, #ff9900)",
    searchButtonShadow: "0 0 12px rgba(255, 77, 0, 0.8)",

    //estilos del modal de detalles
    modalBackdrop: "rgba(0, 0, 0, 0.75)",
    modalBkg: "linear-gradient(180deg, #0b0b0f 0%, #1c1c27 100%)",
    modalBorder: "rgba(255, 153, 0, 0.4)",
    modalBoxShadow: "0 0 25px rgba(0, 229, 255, 0.3)",
    modalButtonGradient: "linear-gradient(90deg, #00e5ff80, #ff9900)",
    modalButtonHover: "linear-gradient(90deg, #ff4d00, #00e5ff)",
    modalTextGlow: "0 0 6px rgba(255, 153, 0, 0.6)",
}

export const lightTheme = { // colores del modo dia
    backgroundSecondary: "#c6cee2",
    backgroundPrimary: "#ffffff",
    txtPrimary: "#000000",
    txtSecondary: "#000",
    surface: "#c0c0c0",
    surfaceSecondary: "#e0e0e0",
    boxShadow: "0 2px 4px rgba(36, 36, 36, 0.62)",
    borderSecondary: "#aa0055",
    btn: "#3fff3fff",
    icon: '#000',
    iconHover: '#ff4d00',

    //estilos del carrito
    cartBkg: "linear-gradient(180deg, #f2f2f5 0%, #e6e6eb 100%)",
    cartBorder: "rgba(255, 153, 0, 0.5)",
    cartBoxShadow: "0 0 25px rgba(255, 153, 0, 0.3)",
    cartHeaderGradient: "linear-gradient(90deg, #ff9900, #ffcc66)",
    cartItemBackground: "rgba(240, 240, 245, 0.85)",
    cartItemHoverGradient: "linear-gradient(90deg, rgba(255, 153, 0, 0.1) 0%, rgba(0, 200, 255, 0.1) 100%)",
    cartButtonBackground: "rgba(255, 153, 0, 0.2)",

    //estilos del buscador
    searchBkg: "rgba(255, 255, 255, 0.9)",
    searchBorder: "rgba(255, 153, 0, 0.6)",
    searchBoxShadow: "0 0 10px rgba(255, 153, 0, 0.4)", 
    searchIcon: "#ff9900", 
    searchIconHover: "#ff4d00",
    searchPlaceholder: "rgba(0, 0, 0, 0.4)", 
    searchButtonGradient: "linear-gradient(90deg, #ff9900, #ffcc66)",
    searchButtonShadow: "0 0 10px rgba(255, 153, 0, 0.6)",

    //estilos del modal de detalles
    modalBackdrop: "rgba(0, 0, 0, 0.45)",
    modalBkg: "linear-gradient(180deg, #f9f9fb 0%, #e8e8ee 100%)",
    modalBorder: "rgba(255, 153, 0, 0.4)",
    modalBoxShadow: "0 0 25px rgba(255, 153, 0, 0.3)",
    modalButtonGradient: "linear-gradient(90deg, #ff9900, #ffcc66)",
    modalButtonHover: "linear-gradient(90deg, #ffcc66, #ff9900)",
    modalTextGlow: "0 0 4px rgba(255, 153, 0, 0.5)",
}